/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Welcome_S2_BadgeInputs */

const en_funnel_ob_welcome_s2_badge = /** @type {(inputs: Funnel_Ob_Welcome_S2_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converted in seconds`)
};

const es_funnel_ob_welcome_s2_badge = /** @type {(inputs: Funnel_Ob_Welcome_S2_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertido en segundos`)
};

/**
* | output |
* | --- |
* | "Converted in seconds" |
*
* @param {Funnel_Ob_Welcome_S2_BadgeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_welcome_s2_badge = /** @type {((inputs?: Funnel_Ob_Welcome_S2_BadgeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Welcome_S2_BadgeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_welcome_s2_badge(inputs)
	return en_funnel_ob_welcome_s2_badge(inputs)
});